import { IPortalInformationState } from '../../states/containersState';
import * as application from '../../actions/containers/application';
import * as _ from 'lodash';

const initialState: IPortalInformationState = {
    portal: null
};

export function portalInfoReducer(state: IPortalInformationState = initialState,
                                   action: application.Actions): IPortalInformationState {
    switch (action.type) {
        case application.ActionTypes.LOAD_PORTAL_INFO_SUCCESS:
            return Object.assign({}, state, {
                portal: action.payload
            });
        default:
            return state;
    }
};

export const getPortalInformation = (portalInformationState: IPortalInformationState) => portalInformationState.portal;



// WEBPACK FOOTER //
// ./src/app/stateManagement/reducers/containers/portalInfo.reducer.ts